import React, { createContext, useContext, useState, useMemo } from 'react';

const BookingContext = createContext();

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
};

export const BookingProvider = ({ children }) => {
  const [bookingDates, setBookingDates] = useState({
    checkIn: '',
    checkOut: '',
    guests: 2,
    nights: 0
  });

  const updateBookingDates = (checkIn, checkOut, guests = 2) => {
    let nights = 0;
    if (checkIn && checkOut) {
      const start = new Date(checkIn);
      const end = new Date(checkOut);
      nights = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
      if (nights < 0) nights = 0;
    }
    
    setBookingDates({
      checkIn,
      checkOut,
      guests,
      nights
    });
  };

  const calculateTotalPrice = (pricePerNight) => {
    if (bookingDates.nights > 0) {
      return pricePerNight * bookingDates.nights;
    }
    return null;
  };

  const formatDateRange = () => {
    if (bookingDates.checkIn && bookingDates.checkOut) {
      const options = { month: 'short', day: 'numeric' };
      const checkIn = new Date(bookingDates.checkIn).toLocaleDateString('en-US', options);
      const checkOut = new Date(bookingDates.checkOut).toLocaleDateString('en-US', options);
      return `${checkIn} - ${checkOut}`;
    }
    return null;
  };

  const value = useMemo(
    () => ({ bookingDates, updateBookingDates, calculateTotalPrice, formatDateRange }),
    [bookingDates],
  );

  return (
    <BookingContext.Provider value={value}>
      {children}
    </BookingContext.Provider>
  );
};

export default BookingContext;
